import {
  CButton,
  CButtonGroup,
  CCol,
  CContainer,
  CModal,
  CModalBody,
  CModalHeader,
  CRow,
} from "@coreui/react";
import { DeleteBucketModal, UpdateBucketModal } from "../forms/BucketModals";
import { MenuButton, UpdateAndDeleteButtonGroup } from "../forms/FormUtils";

import CIcon from "@coreui/icons-react";
import { Can } from "src/helpers/Auth";
import DataTable from "react-data-table-component";
import PropTypes from "prop-types";
import ReactQueryLoading from "src/reusable/ReactQueryLoading";
import { freeSet } from "@coreui/icons";
import { useBucketList } from "./BucketServices";
import { useGetAnalytic } from "../datasets/services/DatasetServices";
import { useHistory } from "react-router-dom";
import React, { useState, useEffect } from "react";
import "../datasets/dataset-style.scss";
import { customDataTableStyle } from "../../reusable/DataTableStyling";

const BucketList = (props) => {
  const history = useHistory();
  const [navigateToBucketId, setNavigateToBucketId] = useState(null);
  const [navigateToAnalyticId, setNavigateToAnalyticId] = useState(null);
  const {
    status: bucketListStatus,
    isLoading: isBucketListLoading,
    error: bucketListError,
    data: bucketList,
  } = useBucketList({
    analyticId: props.analyticId,
    details: props.includeDetails,
  });

  const { data: navigateToAnalytic } = useGetAnalytic(navigateToAnalyticId);

  useEffect(() => {
    // If the analytic is set, navigate to it
    if (navigateToAnalytic && navigateToBucketId) {
      history.push(
        `/datasets/${navigateToAnalytic.dataset_id}/stats?bucketId=${navigateToBucketId}`,
      );
    }
  }, [navigateToAnalytic, navigateToBucketId]);

  const handleBucketClick = (bucketId, analyticId) => {
    setNavigateToBucketId(bucketId);
    setNavigateToAnalyticId(analyticId);
  };

  const hideDescriptionAt =
    1440 -
    (props.includeSelectedLabels ? 0 : 125) -
    (props.includeButtons ? 0 : 190) -
    (props.includeButtons && props.includeJustEditButtons ? 105 : 0) -
    (props.includeDetails ? 0 : 865);

  let bucketListColumns = [
    {
      name: "ID",
      selector: (row) => row.id,
      sortable: true,
      maxWidth: "10px",
      grow: 0.5,
    },
    {
      name: "Name",
      selector: (row) => (
        <div id={"row-name-" + row.name + "-row-id-" + row.id}>{row.name}</div>
      ),
      sortable: true,
      grow: 1.5,
    },
    {
      name: "Description",
      selector: (row) => (
        <span style={{ fontSize: "75%" }}>{row.description}</span>
      ),
      hide: hideDescriptionAt,
      maxWidth: "420px",
      grow: 2,
    },
  ];
  if (props.includeDetails) {
    bucketListColumns.push({
      name: "Dataset",
      selector: (row) => row.dataset.name,
      sortable: true,
      maxWidth: "150px",
      grow: 1,
      hide: 1600,
    });
    bucketListColumns.push({
      name: "Model",
      selector: (row) =>
        row.model.name + " (v" + row.model_version.version_number + ")",
      sortable: true,
      maxWidth: "150px",
      grow: 1,
      hide: 2000,
    });
    bucketListColumns.push({
      name: "Create Date",
      selector: (row) => row.create_date,
      sortable: true,
      maxWidth: "150px",
      grow: 1,
      hide: 1600,
    });
    bucketListColumns.push({
      name: "Create User",
      selector: (row) => row.create_user_display_name,
      sortable: true,
      maxWidth: "150px",
      grow: 1,
      hide: 1722,
    });
    bucketListColumns.push({
      name: "Others Can Edit?",
      grow: 1,
      maxWidth: "150px",

      selector: (row) =>
        row.allow_others_to_edit ? (
          <CIcon name="cil-check-circle" style={{ color: "green" }} />
        ) : (
          ""
        ),
      sortable: true,
      hide: 1824,
    });
  }
  if (props.includeSelectedLabels) {
    bucketListColumns.push({
      name: "Selected Labels",
      selector: (row) => (
        <span style={{ fontSize: "75%" }}>
          {row.selected_labels.join(", ")}
        </span>
      ),
      sortable: true,
      grow: 1.5,
    });
  }
  if (props.includeButtons && !props.includeSelectedLabels) {
    bucketListColumns.push({
      width: props.includeJustEditButtons ? "75px" : "200px",
      compact: true,

      cell: (row) => (
        <div style={{ textAlign: "right", width: "100%", marginRight: "10px" }}>
          <>
            <CButtonGroup className="buttons-radius">
              <Can
                perform="bucket:read"
                yes={() => (
                  <>
                    <MenuButton
                      className="bucket-analysis-button"
                      text="Analyze"
                      color="dark"
                      size="sm"
                      variant="outline"
                      onClick={() => {
                        setNavigateToBucketId(row.id);
                        setNavigateToAnalyticId(row.analytic_fk);
                      }}
                      icon={
                        <CIcon
                          content={freeSet.cilChart}
                          className="text-info"
                        />
                      }
                    />
                  </>
                )}
              />
              <Can
                perform="bucket:update"
                yes={() => (
                  <UpdateAndDeleteButtonGroup
                    id={row.id}
                    itemName="Bucket"
                    updateItemModal={UpdateBucketModal}
                    updateItemModalProps={{
                      bucketName: row.name,
                      bucketDescription: row.description,
                      bucketAllowOthersToEdit: row.allow_others_to_edit,
                    }}
                    deleteItemModal={DeleteBucketModal}
                    deleteItemModalProps={{
                      bucketName: row.name,
                    }}
                    buttonSize={"sm"}
                    updateRole="bucket:update"
                    deleteRole="bucket:delete"
                  />
                )}
                no={() => (
                  <UpdateAndDeleteButtonGroup
                    id={row.id}
                    itemName="Bucket"
                    updateItemModal={UpdateBucketModal}
                    updateItemModalProps={{
                      bucketName: row.name,
                      bucketDescription: row.description,
                      bucketAllowOthersToEdit: row.allow_others_to_edit,
                    }}
                    deleteItemModal={DeleteBucketModal}
                    deleteItemModalProps={{
                      bucketName: row.name,
                    }}
                    buttonSize={"sm"}
                    updateRole="bucket:update"
                    deleteRole="bucket:delete"
                  />
                )}
              />
            </CButtonGroup>
          </>
        </div>
      ),
    });
  }
  if (props.includeSelectedLabels) {
    bucketListColumns.push({
      name: "Actions",
      maxWidth: "350px",
      minWidth: "200px",

      cell: (row) => (
        <div style={{ textAlign: "right", width: "100%", marginRight: "10px" }}>
          <CButtonGroup className="buttons-radius">
            <Can
              perform="bucket:read"
              yes={() => (
                <>
                  <MenuButton
                    className="bucket-analysis-button"
                    text="Analyze"
                    color="dark"
                    size="sm"
                    variant="outline"
                    onClick={() => {
                      setNavigateToBucketId(row.id);
                      setNavigateToAnalyticId(row.analytic_fk);
                    }}
                    icon={
                      <CIcon content={freeSet.cilChart} className="text-info" />
                    }
                  />
                </>
              )}
            />
            <UpdateAndDeleteButtonGroup
              isHidingAnimation={true}
              id={row.id}
              itemName="Bucket"
              updateItemModal={UpdateBucketModal}
              updateItemModalProps={{
                config: props.bucketVisParams,
                bucketName: row.name,
                bucketDescription: row.description,
                bucketAllowOthersToEdit: row.allow_others_to_edit,
              }}
              deleteItemModal={DeleteBucketModal}
              deleteItemModalProps={{
                bucketName: row.name,

                setBucketToNull: props.setBucketToNull,
              }}
              buttonSize={"sm"}
              updateRole="bucket:update"
              deleteRole="bucket:delete"
            />
          </CButtonGroup>
        </div>
      ),
      sortable: false,
      grow: 1.5,
    });
  }

  return (
    <Can
      perform="bucket:read"
      yes={() => (
        <ReactQueryLoading
          isLoading={isBucketListLoading}
          status={bucketListStatus}
          error={bucketListError}
        >
          <DataTable
            columns={bucketListColumns}
            data={bucketList}
            responsive
            highlightOnHover
            pointerOnHover
            customStyles={customDataTableStyle}
            data-attr="buckets:card:bucket-list"
            onRowClicked={(row) => {
              return handleBucketClick(row.id, row.analytic_fk);
            }}
          />
        </ReactQueryLoading>
      )}
      no={() => <div>You do not have permission to view datasets</div>}
    />
  );
};

BucketList.propTypes = {
  analyticId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  bucketVisParams: PropTypes.object,
  onBucketSelect: PropTypes.func,
  includeButtons: PropTypes.bool,
  includeJustEditButtons: PropTypes.bool,
  includeDetails: PropTypes.bool,
  includeSelectedLabels: PropTypes.bool,
};

BucketList.defaultProps = {
  onBucketSelect: () => {},
  includeButtons: true,
  includeJustEditButtons: false,
  includeDetails: true,
  includeSelectedLabels: false,
};

export const BucketListModal = (props) => {
  const onSelect = (bucketId) => {
    props.onBucketSelect(bucketId);
    if (props.closeOnSelect) {
      props.onClose();
    }
  };
  return (
    <CModal
      size={"lg"}
      show={props.isVisible}
      onClose={props.onClose}
      style={{ textAlign: "left" }}
    >
      <CModalHeader>
        <CCol sm="9">
          <h3>Select a Bucket</h3>
        </CCol>
        <CCol sm="3" style={{ textAlign: "right" }}>
          <CButton
            id="bucket-list-close-button"
            data-attr="buckets:btn:close-bucket-list-modal"
            color="secondary"
            onClick={props.onClose}
            size="sm"
          >
            <CIcon name="cil-x" />
          </CButton>
        </CCol>
      </CModalHeader>
      <CModalBody>
        <BucketList
          analyticId={props.analyticId}
          bucketVisParams={props.bucketVisParams}
          onBucketSelect={onSelect}
          includeJustEditButtons={true}
          includeDetails={false}
          includeSelectedLabels={true}
          setBucketToNull={props.setBucketToNull}
        />
      </CModalBody>
    </CModal>
  );
};

BucketListModal.propTypes = {
  analyticId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  bucketVisParams: PropTypes.object,
  isVisible: PropTypes.bool.isRequired,
  onBucketSelect: PropTypes.func,
  onClose: PropTypes.func,
  closeOnSelect: PropTypes.bool,
  setBucketToNull: PropTypes.func,
};
BucketListModal.defaultProps = {
  onClose: () => {},
  onBucketSelect: () => {},
  closeOnSelect: true,
};

const Buckets = () => {
  return (
    <>
      <CContainer data-testid="bkt-container" fluid style={{ marginTop: "1%" }}>
        <CRow>
          <CCol xs="12">
            <div style={{ marginBottom: "1em" }}>
              <h1>Buckets</h1>
              View previously created buckets, and jump directly into analyzing
              the most recent data for those buckets.
              <br />
              Don&apos;t see any buckets? Buckets can be created by clicking the
              &quot;Analyze&quot; button on a dataset, generating a cluster
              analytic, selecting multiple points and clicking &quot;Create
              Bucket&quot;.
              <br></br>
            </div>
          </CCol>
        </CRow>
        <CRow>
          <CCol xs="12">
            <BucketList />
          </CCol>
        </CRow>
      </CContainer>
    </>
  );
};

Buckets.propTypes = {};

export default Buckets;
